import React, { useState } from 'react';
import './loginForm.css';
import { useNavigate } from 'react-router-dom';
import { assets } from '../../../assets/assets';
import { postData } from '../../../services/apiServices';
import toastService from '../../../services/toastService';
import { Bars } from 'react-loader-spinner';
import { useDispatch } from 'react-redux';
import { setUser } from '../../Redux/slices/userSlice';
import Loader from '../../MyComponents/Loader/Loader';

function SignInForm() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch()

  const navigate = useNavigate();


  // const handleSignIn = (event) => {
  //   event.preventDefault();
  //   console.log('Email:', email);
  //   console.log('Password:', password);

  //   navigate('/dashboard');
  // };

  const handleSignIn = async (event) => {
    event.preventDefault();



    const data = {

      email: email,
      password: password,
      verification_token: '123456'
    };

    try {
      setLoading(true);

      const response = await postData('/signin', data);
      console.log('434344 successful:', response);
      if (response?.message === "success") {
        dispatch(setUser(response?.user))
        toastService.showSuccess("Logged In Successfully");
        navigate('/dashboard');
        setEmail('');
        setPassword('');
      } else {
        toastService.showError(response.description)
        setLoading(false);
      }

    } catch (error) {
      console.error('Error signing up:', error);
      toastService.showError('Failed to sign up. Please try again.')
      setLoading(false);
    }
  };
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (

    <>
      <Loader isLoading={loading} />
      <div className='containers'>
        <header className="navbar">
          <div className="logo">
            <img src={assets.logo} alt=" " className='logo-img' />
          </div>
          <a href="/register" className="register-link">Register</a>
        </header>

        <div className="signin-container">

          <div className="signin-form">
            <div className='signin-form1'>
              <h2>Let's Sign In</h2>
              <p>Enter your details to sign in to your account</p>
              <form onSubmit={handleSignIn}>
                <div className="input-field">
                  <div className="input-wrapper">
                    <i className="fas fa-envelope"></i>
                    <input
                      type="email"
                      id="email"
                      placeholder="Enter Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className="input-field">
                  <div className="input-wrapper">
                    <i className="fas fa-lock"></i>
                    <input
                      type={showPassword ? "text" : "password"}
                      id="password"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />

                  </div>
                </div>
                <button type="submit">Sign In</button>
              </form>
            </div>
            <p>Don't have an account? <a href="/register">Register Now</a></p>
          </div>
        </div>
      </div>
    </>

  );
}

export default SignInForm;
